import { useState, useRef, useEffect } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { motion } from "framer-motion";

const GlobalAudioPlayer = () => {
  const audioRef = useRef<HTMLAudioElement>(null);
  const [isMuted, setIsMuted] = useState(true);
  const [hasInteracted, setHasInteracted] = useState(false);

  useEffect(() => {
    const handleFirstInteraction = () => {
      if (!hasInteracted) {
        setHasInteracted(true);
        if (audioRef.current) {
          audioRef.current.volume = 0.3;
          audioRef.current.play().catch(() => {});
        }
      }
    };
    window.addEventListener("click", handleFirstInteraction, { once: true });
    window.addEventListener("touchstart", handleFirstInteraction, { once: true });
    return () => {
      window.removeEventListener("click", handleFirstInteraction);
      window.removeEventListener("touchstart", handleFirstInteraction);
    };
  }, [hasInteracted]);

  const toggleMute = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (audioRef.current) {
      const next = !isMuted;
      audioRef.current.muted = next;
      setIsMuted(next);
      if (!next && audioRef.current.paused) {
        audioRef.current.play().catch(() => {});
      }
    }
  };

  return (
    <>
      <audio ref={audioRef} src="/audio/background-music.mp3" loop muted />
      <motion.button
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 1, duration: 0.3 }}
        onClick={toggleMute}
        className="fixed bottom-[4.5rem] left-4 z-50 w-12 h-12 rounded-full bg-muted/90 backdrop-blur-md border border-border shadow-lg flex items-center justify-center hover:bg-muted transition-colors"
        aria-label={isMuted ? "הפעל סאונד" : "השתק סאונד"}
      >
        {isMuted ? (
          <VolumeX className="w-6 h-6 text-muted-foreground" />
        ) : (
          <Volume2 className="w-6 h-6 text-primary" />
        )}
      </motion.button>
    </>
  );
};

export default GlobalAudioPlayer;
